import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

type FAQFRProps = {
  variant?: 'agents' | 'partenaires';
};

const FAQFR: React.FC<FAQFRProps> = ({ variant = 'agents' }) => {
  const isPartners = variant === 'partenaires';
  const faqData = [
    { id: null, question: 'Y a-t-il un engagement ?', answer: 'Non. Abonnement mensuel, sans engagement. Annulation possible à tout moment. Les crédits non utilisés ne sont pas remboursables, mais restent valables 6 mois, vous avez donc toute la flexibilité pour les utiliser à votre rythme.' },
    { id: null, question: "Comment fonctionne l'abonnement ?", answer: "Chaque formule inclut un nombre de biens par mois. Un bien = un crédit, que vous choisissiez la formule standard (Matterport seul) ou la formule avec clips de drone (Matterport + drone)." },
    { id: null, question: 'Que dois-je envoyer ?', answer: "Uniquement le lien de votre visite Matterport. Si vous choisissez la formule avec drone, partagez également vos clips via Google Drive, Dropbox ou WeTransfer. C'est tout." },
    { id: null, question: 'Qu’est-ce que je reçois par bien ?', answer: "Formule standard : 1 vidéo professionnelle de visite virtuelle Full HD, livrée en 24h, prête à publier sur vos annonces, portails et réseaux sociaux. Formule avec drone : 1 montage vidéo complet intégrant votre visite Matterport et vos clips drone, livré en 24h. Dans les deux cas, vous recevez un fichier vidéo professionnel clé en main." },
    { id: 'faq-turnaround', question: 'Délai de livraison ?', answer: '24 heures. Les commandes passées du lundi au jeudi sont livrées le lendemain. Vendredi = livraison le lundi.' },
    {
      id: null,
      question: 'Puis-je acheter des crédits en plus ?',
      answer: isPartners
        ? 'Oui. Crédits supplémentaires à 95 € par bien (sans drone) ou 135 € (avec drone). Sans limite.'
        : 'Oui. Crédits supplémentaires à 150 € par bien (sans drone) ou 190 € (avec drone). Sans limite.',
    },
    { id: null, question: 'Les crédits non utilisés ?', answer: 'Vos crédits non utilisés ne sont pas remboursables, mais restent valables 6 mois. Utilisez-les quand vous en avez besoin, sans pression.' },
  ];

  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  return (
    <section id="faq" className="py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
        <h2 className="font-manrope text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 animate-fade-in-up">Questions fréquentes</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">Réponses aux questions les plus fréquentes sur notre service</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div key={index} id={faq.id || undefined} className="card-hover bg-white rounded-3xl border border-[#E2E8F0] overflow-hidden">
                <button onClick={() => toggleItem(index)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <span className="font-manrope font-semibold text-gray-900 pr-4">Q : {faq.question}</span>
                  {openItems.includes(index) ? <ChevronUp className="w-5 h-5 text-[#3C59B2] flex-shrink-0" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{ gridTemplateRows: openItems.includes(index) ? '1fr' : '0fr' }}>
                  <div className="min-h-0 overflow-hidden">
                    <div className="px-6 pb-4">
                      <div className="pt-2 border-t border-gray-100">
                        <p className="text-gray-700 leading-relaxed">
                          <span className="font-semibold text-[#3C59B2]">R : </span> {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQFR;
